import ApiService from "../services/ApiService";

function addError(inVO, successCallback, failureCallback) {
    if (!!!__DEV__) {
        ApiService.post("/web/admin/error/details/add", inVO, successCallback, failureCallback);
    }
}

export { addError };
